/* Color scheme toggle: switches between light and dark, persisting the
   choice in localStorage. Until a choice is made, the OS preference applies
   (handled in CSS via prefers-color-scheme) */
(function () {
    const root = document.documentElement;
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const toggles = document.querySelectorAll('[data-color-scheme-toggle]');
    if (!toggles.length) return;

    const current = () => root.dataset.colorScheme || (media.matches ? 'dark' : 'light');

    toggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
            const next = current() === 'dark' ? 'light' : 'dark';
            root.classList.add('gh-scheme-transition');
            root.dataset.colorScheme = next;
            try {
                localStorage.setItem('color-scheme', next);
            } catch (e) {}
            window.setTimeout(function () {
                root.classList.remove('gh-scheme-transition');
            }, 400);
        });
    });
})();
